import { createReducer, on } from '@ngrx/store';
import { formatISO } from 'date-fns';
import { ServiceTask } from 'src/app/types/aggregate-graph.types';
import { hubConnectionClosed } from '../aggregate-graph-hub/aggregate-graph-hub.actions';
import { clearStateRequested } from '../auth/auth.actions';
import * as serviceGraphActions from './service-graph.actions';

export interface State {
	serviceId: string;
	subscribedDate: string;
	serviceLoaded: boolean;
	serviceTasks: ServiceTask[];
}

export const initialState: State = {
	serviceId: '',
	subscribedDate: '',
	serviceLoaded: false,
	serviceTasks: []
}

export const serviceGraphReducer = createReducer(
	initialState,
	on(serviceGraphActions.subscribeServiceRequested, (state, { serviceId }) => ({
		...state,
		serviceId: serviceId.toLocaleLowerCase(), // sometimes users paste in upper case id
		serviceLoaded: false
	})),
	on(serviceGraphActions.serviceGraphGenerated, (state) => ({
		...state,
		subscribedDate: formatISO(new Date())
	})),
	on(serviceGraphActions.serviceGraphLoaded, (state, { serviceTasks }) => ({
		...state,
		serviceTasks: serviceTasks,
		serviceLoaded: true
	})),
	on(serviceGraphActions.serviceTaskAdded, (state, { serviceTask }) => ({
		...state,
		serviceTasks: [...state.serviceTasks, serviceTask]
	})),
	on(serviceGraphActions.serviceTaskUpdated, (state, { partialServiceTask }) => {
		const serviceTask = state.serviceTasks.find(st => st.id === partialServiceTask.id);
		if (!serviceTask) return { ...state };
		return {
			...state,
			serviceTasks: [...state.serviceTasks.filter(st => st.id !== partialServiceTask.id), { ...serviceTask, ...partialServiceTask }]
		}
	}),
	on(serviceGraphActions.serviceTaskRemoved, (state, { serviceTaskId }) => ({
		...state,
		serviceTasks: state.serviceTasks.filter(st => st.id !== serviceTaskId)
	})),
	on(serviceGraphActions.reloadServiceRequested, (state) => ({
		...state,
		subscribedDate: '',
		serviceLoaded: false
	})),
	on(hubConnectionClosed, (state) => ({
		...state,
		subscribedDate: ''
	})),
	on(serviceGraphActions.unsubscribeServiceRequested, () => initialState),
	on(clearStateRequested, () => initialState)
);